import dynamic from 'next/dynamic';
import LoaderPage from '@/reactPages/LoaderPage/LoaderPage';

export const Adverts = dynamic(() => import('./Adverts'), {
  ssr: false,
  loading: () => <LoaderPage/>,
});
